import { useNavigate } from "react-router-dom";
import { useData } from "@/context/DataContext";
import Layout from "@/components/Layout";
import Header from "@/components/Header";
import { motion } from "framer-motion";

export default function CategoriesPage() {
  const navigate = useNavigate();
  const { categoriesResolved } = useData();
  return (
    <Layout>
      <Header subtitle="Explora por categoría" />
      <section className="px-5 pt-4">
        <h2 className="font-display text-3xl font-black tracking-tighter">Categorías</h2>
        <div className="mt-4 grid grid-cols-3 gap-3">
          {categoriesResolved.map((c, i) => (
            <motion.button
              key={c.slug}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: Math.min(i * 0.03, 0.4) }}
              data-testid={`explore-cat-${c.slug}`}
              onClick={() => navigate(`/categoria/${c.slug}`)}
              className="flex aspect-square flex-col items-center justify-center gap-2 rounded-2xl border border-black/5 bg-white shadow-[0_8px_30px_rgba(0,0,0,0.03)]"
            >
              <div
                className="flex h-12 w-12 items-center justify-center rounded-xl"
                style={{ backgroundColor: `${c.color}14` }}
              >
                <c.Icon size={24} style={{ color: c.color }} strokeWidth={2.2} />
              </div>
              <span className="px-1 text-center text-[11px] font-bold leading-tight text-[#1A1A1A]">
                {c.label}
              </span>
            </motion.button>
          ))}
        </div>
      </section>
    </Layout>
  );
}
